import React, { useState } from "react";
import { Col } from "react-bootstrap";
import TextField from "@material-ui/core/TextField";
import { CloseRounded, CheckRounded } from "@material-ui/icons";
import { Button, FormControlLabel, Switch, Radio, RadioGroup, FormControl, FormLabel, Select, MenuItem, Typography } from "@material-ui/core";
import CustomGreenButton from "../../../components/shared/custom-green-button";
import PersonIcon from "@material-ui/icons/Person";
import swal from "sweetalert";
import { toast } from "react-hot-toast";
import { DropzoneArea } from "material-ui-dropzone";
import { crearBanner } from "../../../shared/fetchers/classics/banners/crearBanner";
import { editarBanner } from "../../../shared/fetchers/classics/banners/editarBanner";

const CrearBannerIndividual = ({ banner, clearEdit, onBannerCreated, onVolver }) => {
  const [formData, setFormData] = useState({
    tipoBanner: {
      value: banner?.tipo?.toLowerCase() ?? "imagen",
      error: false,
    },
    titulo: {
      value: banner?.titulo ?? "",
      error: false,
    },
    tituloIngles: {
      value: banner?.tituloEng ?? "",
      error: false,
      optional: true,
    },
    descripcion: {
      value: banner?.descripcion ?? "",
      error: false,
      optional: true,
    },
    descripcionIngles: {
      value: banner?.descripcionEng ?? "",
      error: false,
      optional: true,
    },
    textoBoton: {
      value: banner?.textoBoton ?? "",
      error: false,
    },
    textoBotonIngles: {
      value: banner?.textoBotonEng ?? "",
      error: false,
    },
    enlaceBoton: {
      value: banner?.link ?? "",
      error: false,
    },
    colorFondo: {
      value: banner?.colorFondo ?? "#ffffff",
      error: false,
      optional: true,
    },
    colorTitulo: {
      value: banner?.colorTitulo ?? "#000000",
      error: false,
      optional: true,
    },
    colorDescripcion: {
      value: banner?.colorDescripcion ?? "#666666",
      error: false,
      optional: true,
    },
    colorBoton: {
      value: banner?.colorBoton ?? "#81c868",
      error: false,
      optional: true,
    },
    colorTextoBoton: {
      value: banner?.colotTextoBoton ?? "#ffffff",
      error: false,
      optional: true,
    },
    esGlobal: {
      value: banner?.esGlobal === 1 || banner?.esGlobal === "1",
      error: false,
    },
    posicionGlobal: {
      value: banner?.ordenGlobal?.toString() ?? "1",
      error: false,
      optional: true,
    },
    activo: {
      value: banner?.activo === 1 || banner?.activo === "1",
      error: false,
    },
  });

  let urlBanner = "";
  if(process.env.REACT_APP_API === "https://nf.api.makemake.reallabs.com.co/admin"){
    urlBanner = "https://rc.makemake.reallabs.com.co";
  }else{
    urlBanner = "https://makemake.com.co/makemake";
  }

  const [imagen, setImagen] = useState({
    imageFile: null,
    imageUrl: banner?.urlImagen ? `${urlBanner}${banner.urlImagen}` : null,
    error: false,
  });

  const updateForm = (e) => {
    const { value, name, type, checked } = e.target;
    const finalValue = type === "checkbox" ? checked : value;
    
    setFormData({
      ...formData,
      [name]: { ...formData[name], value: finalValue, error: false },
    });
  };

  const handleImage = (files) => {
    if (files.length === 1) {
      const pickedFile = files[0];
      setImagen({
        imageFile: pickedFile,
        imageUrl: URL.createObjectURL(pickedFile),
        error: false,
      });
    }
  };

  const clearForm = () => {
    let temp = { ...formData };
    for (const formElement in temp) {
      if (formElement === "tipoBanner") {
        temp[formElement] = { ...temp[formElement], value: "imagen", error: false };
      } else if (formElement === "activo") {
        temp[formElement] = { ...temp[formElement], value: true, error: false };
      } else if (formElement === "esGlobal") {
        temp[formElement] = { ...temp[formElement], value: false, error: false };
      } else if (formElement === "posicionGlobal") {
        temp[formElement] = { ...temp[formElement], value: "1", error: false };
      } else if (formElement.includes("color")) {
        // Mantener colores por defecto
      } else {
        temp[formElement] = { ...temp[formElement], value: "", error: false };
      }
    }
    setFormData(temp);
    setImagen({ imageFile: null, imageUrl: null, error: false });
  };

  const validate = () => {
    let isValid = true;
    const temp = { ...formData };

    // Validar imagen: requerida solo para nuevo banner o si no hay imagen actual
    if (!imagen.imageFile && (!banner || !imagen.imageUrl)) {
      setImagen({ ...imagen, error: true });
      isValid = false;
      toast.error("Debes seleccionar una imagen de fondo");
    }

    // Validar campos obligatorios
    for (const formElement of Object.entries(temp)) {
      const [key, value] = formElement;

      // Excluir campos booleanos y numéricos de la validación de "vacío"
      if (!value.optional && 
          value.value !== false && 
          value.value !== 0 && 
          !value.value) {
        value.error = true;
        isValid = false;
        toast.error(`El campo ${key} no puede estar vacío`);
      }
    }

    // Validar URL
    if (!formData.enlaceBoton.value) {
      temp.enlaceBoton.error = true;
      isValid = false;
      toast.error("El enlace del botón debe ser una URL válida");
    }

    setFormData(temp);
    return isValid;
  };


  const submitForm = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    let datosBanner = Object.fromEntries(
      Object.entries(formData).map(([key, value]) => {
        return [key, value.value];
      }),
    );

    try {
      let result;
      
      if (banner) {
        // Modo edición: usar editarBanner con el ID del banner
        result = await editarBanner({ 
          ...datosBanner, 
          imagen: imagen.imageFile,
          idBanners: banner.idBanners
        });
      } else {
        // Modo creación: usar crearBanner
        result = await crearBanner({ 
          ...datosBanner, 
          imagen: imagen.imageFile 
        });
      }
      
      const { status, info } = result;
      
      if (!status) {
        return swal({
          title: "Error",
          text: info ?? `Hubo un error ${banner ? "editando" : "creando"} el banner, inténtalo de nuevo.`,
          icon: "error",
        });
      }

      toast.success(banner ? "Banner editado correctamente" : "Banner creado correctamente");
      
      if (banner && clearEdit) {
        clearEdit();
      }
      
      if (onBannerCreated) {
        onBannerCreated();
      }
      
      if (!banner) {
        clearForm();
        // Si estamos en modo creación y hay función onVolver, regresar a la lista
        if (onVolver) {
          onVolver();
        }
      }
      
    } catch (error) {
      swal({
        title: "Error",
        text: `Hubo un error ${banner ? "editando" : "creando"} el banner, inténtalo de nuevo. `,
        icon: "error",
      });
    }
  };

  return (
    <Col xs={12} className="content-white-box px-4 py-4">
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <PersonIcon style={{ fontSize: "17px" }} />
          <div className="admin-main-title-dark-gray ml-2 mt-1">
            {banner ? "Editar" : "Crear"} Banner
          </div>
        </div>
        {/* Botón de regreso - solo mostrar cuando no hay banner (modo creación) y hay función onVolver */}
        {!banner && onVolver && (
          <Button
            variant="outlined"
            onClick={onVolver}
            startIcon={<CloseRounded />}
          >
            Volver a la lista
          </Button>
        )}
      </div>
      <div className="admin-muted-text-small mt-2">
        Los campos opcionales están marcados con (Opcional), los demás son obligatorios
      </div>

      <form onSubmit={submitForm}>
        {/* Sección 1: Tipo de Banner */}
        <div className="mt-4">
          <FormControl component="fieldset" className="mt-2">
          <label className="admin-label-text mt-3 d-block">TIPO DE BANNER*</label>
            <RadioGroup
              name="tipoBanner"
              value={formData.tipoBanner.value}
              onChange={updateForm}
              row
            >
              <FormControlLabel className="admin-text"
                value="imagen"
                control={<Radio color="primary" />}
                label="Imagen"
              />
              <FormControlLabel className="admin-text"
                value="editable"
                control={<Radio color="primary" />}
                label="Editable"
              />
            </RadioGroup>
          </FormControl>
        </div>

        {/* Sección 2: Contenido (Textos) */}
        <div className="mt-4">         
          <label className="admin-label-text mt-3 d-block">Título *</label>
          <TextField
            name="titulo"
            value={formData.titulo.value}
            onChange={updateForm}
            error={formData.titulo.error}
            helperText={formData.titulo.error ? "Este campo es obligatorio" : null}
            variant="outlined"
            size="small"
            placeholder="Título del banner"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />

          <label className="admin-label-text mt-3 d-block">Título (Inglés) (Opcional)</label>
          <TextField
            name="tituloIngles"
            value={formData.tituloIngles.value}
            onChange={updateForm}
            error={formData.tituloIngles.error}
            variant="outlined"
            size="small"
            placeholder="Title in English"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />

          <label className="admin-label-text mt-3 d-block">Descripción (Opcional)</label>
          <TextField
            name="descripcion"
            value={formData.descripcion.value}
            onChange={updateForm}
            error={formData.descripcion.error}
            variant="outlined"
            size="small"
            multiline
            rows={2}
            placeholder="Descripción del banner"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />

          <label className="admin-label-text mt-3 d-block">Descripción (Inglés) (Opcional)</label>
          <TextField
            name="descripcionIngles"
            value={formData.descripcionIngles.value}
            onChange={updateForm}
            error={formData.descripcionIngles.error}
            variant="outlined"
            size="small"
            multiline
            rows={2}
            placeholder="Description in English"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />

          <label className="admin-label-text mt-3 d-block">Texto del Botón *</label>
          <TextField
            name="textoBoton"
            value={formData.textoBoton.value}
            onChange={updateForm}
            error={formData.textoBoton.error}
            helperText={formData.textoBoton.error ? "Este campo es obligatorio" : null}
            variant="outlined"
            size="small"
            placeholder="Texto que aparecerá en el botón"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />

        <label className="admin-label-text mt-3 d-block">Texto del Botón Inglés *</label>
          <TextField
            name="textoBotonIngles"
            value={formData.textoBotonIngles.value}
            onChange={updateForm}
            error={formData.textoBotonIngles.error}
            helperText={formData.textoBotonIngles.error ? "Este campo es obligatorio" : null}
            variant="outlined"
            size="small"
            placeholder="Texto que aparecerá en el botón en inglés"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />

          <label className="admin-label-text mt-3 d-block">Enlace del Botón (URL) *</label>
          <TextField
            name="enlaceBoton"
            value={formData.enlaceBoton.value}
            onChange={updateForm}
            error={formData.enlaceBoton.error}
            helperText={formData.enlaceBoton.error ? "Debe ser una URL válida" : null}
            variant="outlined"
            size="small"
            placeholder="https://ejemplo.com"
            style={{ width: "100%", fontFamily: "'Noto Sans JP', sans-serif" }}
          />
        </div>

        {/* Sección 3: Diseño Visual */}
        <div className="mt-4">
          <label className="admin-label-text mt-3 d-block">Imagen de Fondo *</label>
          <div className="admin-muted-text-small" style={imagen.error ? { color: "red" } : null}>
            Recomendado: 1200x400px, menor a 500KB. Formatos: PNG, JPEG, JPG
            {banner && " | Al editar, puedes mantener la imagen actual o subir una nueva"}
          </div>
          
          {banner && imagen.imageUrl && !imagen.imageFile && (
            <div className="mb-3">
              <div className="admin-muted-text-small mb-2">Imagen actual:</div>
              <img 
                src={imagen.imageUrl} 
                alt="Imagen actual del banner" 
                style={{ 
                  maxWidth: "300px", 
                  maxHeight: "150px", 
                  objectFit: "cover", 
                  border: "1px solid #ddd",
                  borderRadius: "4px"
                }} 
              />
            </div>
          )}
          
          <DropzoneArea
            dropzoneText={banner ? "Arrastra una nueva imagen o mantén la actual" : "Arrastra una imagen o haz click aquí"}
            showFileNames={true}
            showAlerts={true}
            filesLimit={1}
            acceptedFiles={["image/png", "image/jpeg", "image/jpg"]}
            onChange={handleImage}
            maxFileSize={500000} // 500KB
          />

          {/* Preview del Banner */}
          {(banner || imagen.imageUrl || (formData.titulo.value && formData.textoBoton.value)) && (
            <div className="mt-4">
              <label className="admin-label-text d-block">Vista Previa del Banner</label>
              <div 
                className="banner-preview"
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '300px',
                  borderRadius: '8px',
                  overflow: 'hidden',
                  border: '2px solid #e0e0e0',
                  backgroundImage: imagen.imageUrl ? `url(${imagen.imageUrl})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: formData.tipoBanner.value === 'editable' ? formData.colorFondo.value : 'transparent'
                }}
              >
                {/* Overlay para mejor legibilidad en banners de imagen */}
                {formData.tipoBanner.value === 'imagen' && (
                  <div 
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.3)',
                      zIndex: 1
                    }}
                  />
                )}
                
                {/* Contenido del banner */}
                <div 
                  style={{
                    position: 'relative',
                    zIndex: 2,
                    textAlign: 'center',
                    padding: '20px',
                    maxWidth: '600px',
                    color: formData.tipoBanner.value === 'imagen' ? '#ffffff' : formData.colorTitulo.value
                  }}
                >
                  {/* Título */}
                  {formData.titulo.value && (
                    <h2 
                      style={{
                        fontSize: '2rem',
                        fontWeight: 'bold',
                        marginBottom: '10px',
                        color: formData.tipoBanner.value === 'imagen' ? '#ffffff' : formData.colorTitulo.value,
                        textShadow: formData.tipoBanner.value === 'imagen' ? '2px 2px 4px rgba(0,0,0,0.5)' : 'none'
                      }}
                    >
                      {formData.titulo.value}
                    </h2>
                  )}
                  
                  {/* Descripción */}
                  {formData.descripcion.value && (
                    <p 
                      style={{
                        fontSize: '1.1rem',
                        marginBottom: '20px',
                        color: formData.tipoBanner.value === 'imagen' ? '#f0f0f0' : formData.colorDescripcion.value,
                        textShadow: formData.tipoBanner.value === 'imagen' ? '1px 1px 2px rgba(0,0,0,0.5)' : 'none'
                      }}
                    >
                      {formData.descripcion.value}
                    </p>
                  )}
                  
                  {/* Botón */}
                  {formData.textoBoton.value && (
                    <button
                      type="button"
                      style={{
                        backgroundColor: formData.colorBoton.value,
                        color: formData.colorTextoBoton.value,
                        border: 'none',
                        padding: '12px 24px',
                        borderRadius: '6px',
                        fontSize: '1rem',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'transform 0.2s',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (formData.enlaceBoton.value) {
                          window.open(formData.enlaceBoton.value, '_blank');
                        }
                      }}
                      onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                      onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                    >
                      {formData.textoBoton.value}
                    </button>
                  )}
                </div>
              </div>
              
              {/* Información adicional del preview */}
              <div className="mt-2 admin-muted-text-small">
                <div className="row">
                  <div className="col-md-4">
                    <strong>Tipo:</strong> {formData.tipoBanner.value === 'imagen' ? 'Banner de Imagen' : 'Banner Editable'}
                  </div>
                  <div className="col-md-4">
                    <strong>Estado:</strong> {formData.activo.value ? 'Activo' : 'Inactivo'}
                  </div>
                  <div className="col-md-4">
                    <strong>Alcance:</strong> {formData.esGlobal.value ? `Global (Pos. ${formData.posicionGlobal.value})` : 'Local'}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Colores - Solo para tipo Editable */}
          {formData.tipoBanner.value === "editable" && (
            <div className="mt-3">
              <Typography variant="subtitle1" className="admin-main-title-dark-gray">
                Colores Personalizables
              </Typography>
              
              <div className="row mt-2">
                <div className="col-md-6">
                  <label className="admin-label-text mt-2 d-block">Color de Fondo</label>
                  <TextField
                    name="colorFondo"
                    value={formData.colorFondo.value}
                    onChange={updateForm}
                    type="color"
                    variant="outlined"
                    size="small"
                    style={{ width: "100px" }}
                  />
                </div>
                <div className="col-md-6">
                  <label className="admin-label-text mt-2 d-block">Color del Título</label>
                  <TextField
                    name="colorTitulo"
                    value={formData.colorTitulo.value}
                    onChange={updateForm}
                    type="color"
                    variant="outlined"
                    size="small"
                    style={{ width: "100px" }}
                  />
                </div>
              </div>
              
              <div className="row mt-2">
                <div className="col-md-6">
                  <label className="admin-label-text mt-2 d-block">Color de la Descripción</label>
                  <TextField
                    name="colorDescripcion"
                    value={formData.colorDescripcion.value}
                    onChange={updateForm}
                    type="color"
                    variant="outlined"
                    size="small"
                    style={{ width: "100px" }}
                  />
                </div>
                <div className="col-md-6">
                  <label className="admin-label-text mt-2 d-block">Color del Botón</label>
                  <TextField
                    name="colorBoton"
                    value={formData.colorBoton.value}
                    onChange={updateForm}
                    type="color"
                    variant="outlined"
                    size="small"
                    style={{ width: "100px" }}
                  />
                </div>
              </div>
              
              <div className="row mt-2">
                <div className="col-md-6">
                  <label className="admin-label-text mt-2 d-block">Color del Texto del Botón</label>
                  <TextField
                    name="colorTextoBoton"
                    value={formData.colorTextoBoton.value}
                    onChange={updateForm}
                    type="color"
                    variant="outlined"
                    size="small"
                    style={{ width: "100px" }}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Sección 4: Configuración y Alcance */}
        <div className="mt-4">          
          <div className="mt-3">
            <FormControlLabel
              control={
                <Switch
                  checked={formData.esGlobal.value}
                  onChange={updateForm}
                  name="esGlobal"
                  color="primary"
                  disabled={!!banner}
                />
              }
              label={`¿Es un banner Global?${banner ? ' (No editable)' : ''}`}
            />
          </div>

          {formData.esGlobal.value && (
            <div className="mt-2">
              <label className="admin-label-text d-block">Posición Global</label>
              <Select
                name="posicionGlobal"
                value={formData.posicionGlobal.value}
                onChange={updateForm}
                variant="outlined"
                size="small"
                style={{ width: "150px" }}
              >
                <MenuItem value="1">Posición 1</MenuItem>
                <MenuItem value="2">Posición 2</MenuItem>
                <MenuItem value="3">Posición 3</MenuItem>
                <MenuItem value="4">Posición 4</MenuItem>
              </Select>
              <div className="admin-muted-text-small mt-1">
                Selecciona la posición donde aparecerá el banner globalmente
              </div>
            </div>
          )}

          <div className="mt-3">
            <FormControlLabel
              control={
                <Switch
                  checked={formData.activo.value}
                  onChange={updateForm}
                  name="activo"
                  color="primary"
                />
              }
              label={`Estado: ${formData.activo.value ? "Activo" : "Inactivo"}`}
            />
          </div>
        </div>

        {/* Botones de Acción */}
        <div className="d-flex justify-content-end mt-4">
          <Button
            variant="contained"
            color="primary"
            type="submit"
            startIcon={<CheckRounded />}
            style={{ background: "#81c868" }}
          >
            {banner ? "Guardar Cambios" : "Crear Banner"}
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              clearForm();
              if (banner && clearEdit) {
                clearEdit();
              } else if (!banner && onVolver) {
                onVolver();
              }
            }}
            className="ml-2"
            startIcon={<CloseRounded />}
            style={{ background: "#f05050" }}
          >
            Cancelar
          </Button>
        </div>
      </form>
    </Col>
  );
};

export default CrearBannerIndividual; 